import React from "react";
import styled, { keyframes } from "styled-components";
import COLORS from "../styled.constants";
import { motion } from "framer-motion";

const Home = () => {
  const Wrapper = styled.div`
    display: flex;
    height: 100vh;
  `;
  const Right = styled.div`
    flex: 3;
    position: relative;
    @media screen and (max-width: 912px) {
      width: 100%;
      display: none;
      /* /* font-size: 0.4em; */
      padding: 0; */
    }
  `;
  const Left = styled.div`
    flex: 1;
  `;

  const Intro = styled.div`
    position: absolute;
    top: 14rem;
    left: 10rem;
    line-height: 8rem;
    h1 {
      color: ${COLORS.title};
      font-size: 3em;
      font-weight: 200;
    }
  `;

  const animation = keyframes`
    0% {opacity: 0; transform: translate()(-100px) skewY(10deg) skewX(10deg) rotateZ(30deg); filter: blur()(10px);}
    25% {opacity: 1; transform: translate()(0px) skewY(0deg) skewX(0deg) rotateZ(0deg); filter: blur()(0px);}
    75% {opacity: 0; transform: translate()(0px) skewY(0deg) skewX(0deg) rotateZ(0deg); filter: blur()(0px);}
    100% {opacity: 1; transform: translate()(-100px) skewY(10deg) skewX(10deg) rotateZ(30deg); filter: blur()(10px);}
  `;

  const Item = styled.span`
    display: inline-block;
    span {
      color: ${COLORS.button};
      display: inline-block;
      opacity: 0;
      animation-name: ${animation};
      animation-duration: 6s;
      animation-fill-mode: forwards;
      animation-iteration-count: infinite;
    }
    span:nth-child(1) {
      animation-delay: 0.5s;
    }
    span:nth-child(2) {
      animation-delay: 0.6s;
    }
    span:nth-child(3) {
      animation-delay: 0.9s;
    }
    span:nth-child(4) {
      animation-delay: 0.8s;
    }
    span:nth-child(5) {
      animation-delay: 1s;
    }
    span:nth-child(6) {
      animation-delay: 0.8s;
    }
  `;

  const textArrayOne = "design".split("");
  const textArrayTwo = "code".split("");

  const PageTransition = styled(motion.div)``;

  return (
    <PageTransition
      as={motion.div}
      initial={{ opacity: 0, scaleX: 0 }}
      animate={{ opacity: 1, scaleX: 1 }}
      exit={{ opacity: 0, scaleX: 0 }}
      transition={{ duration: 0.5 }}
    >
      {/* <Wrapper> */}
      <Right>
        <Intro>
          <h1>
            I{" "}
            <Item>
              {textArrayOne.map((item, indx) => (
                <span key={indx}>{item}</span>
              ))}
            </Item>{" "}
            and{" "}
            <Item>
              {textArrayTwo.map((item, indx) => (
                <span key={indx}>{item}</span>
              ))}
            </Item>{" "}
            <br />
            beautifully simple things.
          </h1>
        </Intro>
      </Right>
      <Left></Left>
      {/* </Wrapper> */}
    </PageTransition>
  );
};

export default Home;
